import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

export function Section({ children, className, eyebrow, title, lead, align = 'left', id }) {
    return (
        <section id={id} className={cn('container-atelier py-16 sm:py-20 lg:py-28', className)}>
            {(eyebrow || title || lead) && (
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: '-80px' }}
                    transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                    className={cn(
                        'mb-10 sm:mb-14 max-w-2xl',
                        align === 'center' && 'mx-auto text-center',
                    )}
                >
                    {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
                    {title && (
                        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight text-balance">
                            {title}
                        </h2>
                    )}
                    {lead && (
                        <p className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed max-w-prose">
                            {lead}
                        </p>
                    )}
                </motion.div>
            )}
            {children}
        </section>
    );
}
